import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { platformRoles } from '../_helpers/types';
import { navigateRoutes } from './route';
import { AuthContext } from '../_hooks/useAuthContext';
import { Spin } from 'antd';

export const BaseRoute = (props) => {
  const { user, authenticated, userLoading } = useContext(AuthContext);

  return userLoading ? <Spin /> : authenticated && user?.role === platformRoles.admin ? (
    <Navigate to={navigateRoutes.savedUsers} />
  ) : authenticated && user?.role === platformRoles.user ? (
    <Navigate to={navigateRoutes.savedContacts} />
  ) : (
    <Navigate to="/sign-in" />
  );
};

export const PrivateRoute = (props) => {
  const { authenticated, userLoading } = useContext(AuthContext);
  return userLoading ? <Spin /> : authenticated ? <Outlet /> : <Navigate to="/sign-in" />;
};

export const PublicRoute = (props) => {
 
  const { authenticated, userLoading } = useContext(AuthContext);
  return userLoading ? <Spin /> : authenticated ? <Navigate to="/" /> : <Outlet />;
};

